import React, { useState } from "react";
import "./galeria.css";
import ImgTitle from '../../../layout/ImgTitle/ImgTitle';

const classes = [
  "random-style-1",
  "random-style-2",
  "random-style-3",
  "random-style-4",
  "random-style-5",
  "random-style-6"
];

const getStaticClass = (id) => classes[id % classes.length];

const Galeria = ({ dataGalery }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const strapiBase = process.env.REACT_APP_STRAPI_API_BASE.replace("/api", "");

  const galeriaImages = dataGalery?.galeriaImagen || [];
  const galeriaBannerDesk = dataGalery?.imagenBannerGaleriaEscritorio?.url;
  const galeriaBannerMob = dataGalery?.imagenBannerGaleriaMobile?.url;

  // console.log(galeriaBannerDesk, "galeriaBannerDesk");

  const openModal = (index) => {
    setSelectedIndex(index);
    setModalOpen(true);
  };

  const closeModal = () => {
    setSelectedIndex(null);
    setModalOpen(false);
  };

  const nextImage = () => {
    setSelectedIndex((prevIndex) => (prevIndex + 1) % galeriaImages.length);
  };

  const prevImage = () => {
    setSelectedIndex((prevIndex) =>
      prevIndex === 0 ? galeriaImages.length - 1 : prevIndex - 1
    );
  };

  if (!Array.isArray(galeriaImages) || galeriaImages.length === 0) {
    return <div className="text-center p-5">No hay imágenes para mostrar.</div>;
  }

  return (
    <>
      <ImgTitle
        desktopImage={strapiBase + galeriaBannerDesk}
        mobileImage={strapiBase + galeriaBannerMob}
      />
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="gallery-container">
              <div className="image-gallery box">
                {galeriaImages.map((image, index) => (
                  <div
                    key={image.id}
                    className={`image-item inner ${getStaticClass(image.id)}`}
                    style={{
                      backgroundImage: `url(${strapiBase}${image.url})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      cursor: "pointer"
                    }}
                    title={image.name}
                    onClick={() => openModal(index)}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        {modalOpen && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close" onClick={closeModal}>✕</button>
              <button className="modal-prev" onClick={prevImage}>❮</button>
              <div
                className="modal-imge"
                style={{
                  backgroundImage: `url(${strapiBase}${galeriaImages[selectedIndex].url})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  width: "90vw",
                  height: "90vh"
                }}
              />
              <button className="modal-next" onClick={nextImage}>❯</button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Galeria;
